import store from '@/state/store';
import projectSlice from '@/state/project.slice';
import { getShareCode } from '@/api/project';
import { handleError } from '@/actions/common';
import { ApiError } from '@bimdata/client';

export default async function (project: string): Promise<void> {
  try {
    const code = await getShareCode(project);
    store.dispatch(projectSlice.actions.setShareCode({project, code }));
  } catch (error) {
    if (error instanceof ApiError && error.code === 404) {
      store.dispatch(projectSlice.actions.setShareCode({ project, code: null }));
      return;
    }
    handleError(error);
  }
};